var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.350031 5.05494C0.0351142 5.38903 -0.0776804 5.86578 0.0541372 6.30555C0.186111 6.74532 0.542494 7.08134 0.989381 7.18715C1.43612 7.29281 1.9053 7.15208 2.22036 6.81799L3.71442 5.23402L3.71442 12.7443C3.72467 13.1962 3.97167 13.6095 4.36508 13.8326C4.75832 14.0558 5.23983 14.0558 5.63307 13.8326C6.02632 13.6095 6.27346 13.1962 6.28373 12.7443L6.28373 5.23402L7.78046 6.81783C8.09568 7.15177 8.565 7.29208 9.01174 7.18596C9.45832 7.07999 9.81458 6.74367 9.94611 6.30375C10.0776 5.86398 9.96454 5.38738 9.64932 5.05345L5.93151 1.11532C5.68852 0.859102 5.35086 0.714048 4.99775 0.714048C4.64465 0.714048 4.30699 0.859098 4.06399 1.11532L0.350031 5.05494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.75243dbbc9bff8c11570eb29ccfee142.svg";
export { ForwardRef as ReactComponent };